import React from 'react';
import { useTranslation } from 'react-i18next';
import { SAPContact } from '../../types';
import styles from './SapContact.module.css';

interface SapContactActionsProps {
  contact: SAPContact;
  callerNumber?: string | null;
  linkedContactId: string | null;
  onLink: (contact: SAPContact) => void;
}

export function SapContactActions({
  contact,
  callerNumber,
  linkedContactId,
  onLink,
}: SapContactActionsProps) {
  const { t } = useTranslation();
  const isLinked = linkedContactId === contact.id;
  const canLink = Boolean(contact.phone || callerNumber);

  return (
    <div className={styles.sapOpenButtonGroup}>
      <button
        type="button"
        className={`${styles.sapLinkButton} ${isLinked ? styles.sapLinkButtonLinked : ''}`}
        onClick={() => onLink(contact)}
        disabled={!canLink}
        title={t('call:sap.openAndLinkTitle')}
      >
        {isLinked ? (
          <>
            <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
            </svg>
            {t('call:sap.linked')}
          </>
        ) : (
          <>
            <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
            {t('call:sap.openAndLink')}
          </>
        )}
      </button>
    </div>
  );
}
